import { faTag } from '@fortawesome/pro-light-svg-icons'
import { useCallback } from 'react'
import { ITLayoutTableModalOpenSetTy } from '../../../../../../../baseComponents/TwinTable/InputTableLayout/InputTable/types'
import { RowData } from '../../../../../../../baseComponents/TwinTable/types'
import { ParameterValueType } from '../../../../../../../baseComponents/TwinTable/VirtualTableListing/Subcomponents/types'
import useTwinTranslation from '../../../../../../../utils/hooks/useTwinTranslation'
import { ITIconToolTip } from '../../../../../../../baseComponents/TwinTable/InputTableLayout/InputTable/Components/Displays'

export interface OrderPrintTagsProps {
    setOpenModal: ITLayoutTableModalOpenSetTy
    value: ParameterValueType
    allRowData: RowData
}

const OrderPrintTags: React.FC<OrderPrintTagsProps> = ({ setOpenModal, allRowData }) => {
    const {t} = useTwinTranslation()
    const myOpenModal = useCallback(() => {
        setOpenModal({ type: 'printTags', allRowData: {...allRowData, tagQuantity: allRowData.quantity} })
    }, [setOpenModal, allRowData])

    return (
        <div className='flex justify-center items-center flex-auto'>
            <ITIconToolTip message={t('printTags', 'Imprimir etiquetas')} id={'printTags' + allRowData?.id || ''} icon={faTag} onClick={myOpenModal} />
        </div>
    )
}

export default OrderPrintTags
